module.exports = __webpack_public_path__ + "static/img/blog-1.016d72d3.jpg";